var /**
 * TODO:
 * `Currencies` is a duplicate of `packages/state/src/Intl/IntlContext/IntlContext.tsx`
 *
 * We can't import these from the `state` package, because of cyclic dependency errors.
 * The best approach would be to create a separate package to host all the `Intl` configuration.
 */ Currencies;
(function(Currencies) {
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
})(Currencies || (Currencies = {}));
const CURRENCIES = Object.keys(Currencies);
const DEFAULT_CURRENCY = Currencies.EUR;
const DEFAULT_FORMAT = '--';
const formatPrice = ({ locale , value , currency , isCentAmount  })=>{
    if (value === undefined || isNaN(value)) {
        return DEFAULT_FORMAT;
    }
    var ref;
    // Only use supported currencies or fallback to default currency
    const priceCurrency = (ref = Currencies[currency || '']) !== null && ref !== void 0 ? ref : DEFAULT_CURRENCY;
    const number = isCentAmount ? value / 100 : value;
    const fractionDecimals = value % (isCentAmount ? 100 : 1) === 0 ? 0 : 2;
    const price = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: priceCurrency,
        minimumFractionDigits: fractionDecimals,
        maximumFractionDigits: fractionDecimals
    }).format(number);
    return price;
};

export { CURRENCIES, formatPrice };
//# sourceMappingURL=format-price.js.map
